import { action } from 'satcheljs/lib/legacy';
import datapoints from '../datapoints';
import densityOptionSelectedValue from '../utils/densityOptionSelectedValue';
import getDensityOptionState from '../store/store';
import getUserConfiguration from 'owa-session-store/lib/actions/getUserConfiguration';
import { logUsage } from 'owa-analytics';
import { ListViewBitFlagsMasks, setBit } from 'owa-bit-flags/lib/utils/listViewBitFlagsUtil';
import { saveDensityModeFromQuickSettingsService } from '../services/saveDensityModeService';

export default action('saveDensityOptionQuickSettings')(
    async function saveDensityOptionQuickSettings() {
        // Save density mode and update features based on the density mode selected
        // From quick settings message height will change and features will toggle
        const densityOptionSelected = getDensityOptionState().densityModeSelected;
        getUserConfiguration().UserOptions.DisplayDensityMode = densityOptionSelected;

        // For Datapoints logging
        const {
            name: eventName,
            customData: customData,
        } = datapoints.DisplayDensityQuickSettings.datapoint;
        logUsage(eventName, customData(densityOptionSelected));

        let isInlinePreviewEnabled, isSenderImageHidden, isdateHeadersDisabled;
        if (densityOptionSelected === 'Full') {
            // Toggle sender image, date header and inline preview features based on the density mode selected
            isSenderImageHidden = false;
            isdateHeadersDisabled = false;
            isInlinePreviewEnabled = true;
        } else if (densityOptionSelected === 'Simple') {
            isSenderImageHidden = true;
            isdateHeadersDisabled = false;
            isInlinePreviewEnabled = true;
        } else if (densityOptionSelected === 'Compact') {
            isSenderImageHidden = true;
            isdateHeadersDisabled = true;
            isInlinePreviewEnabled = false;
        }
        setBit(isSenderImageHidden /* value */, ListViewBitFlagsMasks.HideSenderImage);
        setBit(isdateHeadersDisabled /* value */, ListViewBitFlagsMasks.DateHeadersDisabled);
        getUserConfiguration().UserOptions.ShowInlinePreviews = isInlinePreviewEnabled;

        const listViewBitFlagsValue = getUserConfiguration().ViewStateConfiguration
            .ListViewBitFlags;
        const densityOptionValue = densityOptionSelectedValue(densityOptionSelected);
        await saveDensityModeFromQuickSettingsService(
            densityOptionValue,
            isInlinePreviewEnabled,
            listViewBitFlagsValue
        );
    }
);
